@import '../../../globals/main.scss';
@import './pn-proxio-productcard-common.scss';

pn-proxio-productcard {
  .cardcontent {
    display: flex;
    flex-direction: row;
    border: solid 0.1rem $gray25;
    border-radius: 0.8rem;
    overflow: hidden;
    margin-left: auto;
    margin-right: auto;
    margin-bottom: 1.6rem;

    @media screen and (max-width: $productcard-media-tablet) {
      flex-direction: column;
    }
  }

  .carddetails {
    min-width: 70%;
    padding: 2.4rem 4.8rem;
    display: flex;
    gap: 0.8rem;
    flex-direction: column;

    @media screen and (max-width: $productcard-media-tablet) {
      gap: 1.6rem;
      margin-bottom: 0.8rem;
    }

    pn-illustration[slot='illustrationmobile'] {
      display: none;

      @media screen and (max-width: $productcard-media-tablet) {
        margin-top: 1.6rem;
        display: block;

        .pn-illustration {
          max-width: 8rem;
          height: 8rem;
          margin-left: auto;
          margin-right: auto;
        }
      }
    }
  }

  .cardcalltoactions {
    min-width: 30%;
    background-color: $blue25;

    pn-illustration[slot='illustration'] {
      @media screen and (max-width: $productcard-media-tablet) {
        display: none;
      }

      display: flex;
      flex-direction: column;
      justify-content: center;
      align-content: center;
      max-width: 12rem;
      margin-left: auto;
      margin-right: auto;
      margin-top: 4rem;
    }
  }

  [slot='information'] {
    display: flex;
    gap: 1rem;

    @media screen and (max-width: $productcard-media-tablet) {
      flex-direction: column;
      gap: 1.6rem;
    }
  }

  [slot='uppertags'] {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: flex-start;
    align-items: center;
    gap: 2rem;
  }

  [slot='bottomtags'] {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: flex-start;
    align-items: center;
    gap: 2rem;
    margin: 0.8rem 0;
  }

  .heading {
    display: flex;
    justify-content: space-between;
    flex-direction: row;
  }

  [slot='title'] {
    text-decoration: underline;

    @media screen and (max-width: $productcard-media-tablet) {
      text-decoration: none;
    }
  }
}
